import React from "react";
import {SGLink} from "../../component";

export const PresskitBtn = props => {
    let className = "underline "
    if(props.className) className += props.className;

    return <SGLink to="/press" className={className}>PRESSKIT</SGLink>
}